// src/pages/Ubicacion.js
import React from 'react';
import '../styles/Ubicacion.css';

const Ubicacion = () => {
  return (
    <div className="container mt-5 d-flex flex-column align-items-center">
      <h1>Centro Analítico de Patología</h1>
      <h2 className="text-center">
        Nos encontramos en Av. Manuel Acuña 2844-Interior 6, Colonia Prados Providencia, Guadalajara, Jal.
      </h2>
      <div className="map-container">
        <iframe
          width="100%"
          height="450"
          style={{ border: 0 }}
          loading="lazy"
          allowFullScreen
          referrerPolicy="no-referrer-when-downgrade"
          src={`https://www.google.com/maps/embed/v1/place?key=AIzaSyCamDozuS_qHScZY3Q9dPKyatvtkmsmzLk
            &q=Centro+analítico+de+patología,Guadalajara+Jal`}
          title="Ubicación del Centro Analítico de Patología"
        ></iframe>
      </div>
    </div>
  );
};

export default Ubicacion;
